
import React, { useEffect, useMemo } from "react";
import { DadosOrdemDeProducao } from "./consulta-ordem-de-producao/ConsultaOrdemDeProducao";


const estilosBotoes = require("../../estilos/botoes.module.scss").default

export type CancelarGeracaoOrdemDeProducaoProps = {
    ordemProducao?: Partial<DadosOrdemDeProducao>
    onGerarCancelamento: () => void
    processando: boolean
}

export const CancelarGeracaoOrdemDeProducao = (props: CancelarGeracaoOrdemDeProducaoProps) => {

    const renderDadosPedido = useMemo(() => (
            <div className="_my-4" id="CancelarGeracaoOrdemProducao_dadosPedido">
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                    <p className="_mb-0 _p-2"
                        id="CancelarGeracaoOrdemProducao_NumeroPedido"
                    >{props.ordemProducao?.NumeroPedido}</p>
                </div>
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Produto</label>
                    <p className="_mb-0 _p-2"
                        id="CancelarGeracaoOrdemProducao_Produto"
                    >{`${props.ordemProducao?.CodigoProdutoMostrar} - ${props.ordemProducao?.DescricaoProduto}`}</p>
                </div>
            </div>
        ), [props.ordemProducao])
        
    return (
        <>
            {renderDadosPedido}
            <div>
                <button 
                    className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                    title="Confirma o Cancelar Geração Ordem Produção"
                    id="CancelarGeracaoOrdemProducao_pesquisar"
                    disabled={props.processando}
                    onClick={props.onGerarCancelamento}
                >
                    {props.processando ? "Processando. Aguarde..." : "Confirmar"}
                </button>
      
            </div>
        </>
    )
}